import React from 'react';
import { motion } from 'framer-motion';
import { Sprout, Building, Crosshair, Users, Network, Briefcase } from 'lucide-react';
const tomos = [{
  n: 'TOMO 1',
  Icon: Sprout,
  title: 'Jardín de Fútbol',
  desc: '4 y 5 años. Iniciación, psicomotricidad y primeros contactos con la pelota.'
}, {
  n: 'TOMO 2',
  Icon: Building,
  title: 'Los Cimientos',
  desc: '6 y 7 años. Fundamentos técnicos básicos y juegos reducidos.'
}, {
  n: 'TOMO 3',
  Icon: Crosshair,
  title: 'El Arte del 1 vs 1',
  desc: '8 y 9 años. Duelos, gambeta, resolución individual y técnica aplicada.'
}, {
  n: 'TOMO 4',
  Icon: Users,
  title: 'El Equipo',
  desc: '10 años. Juego asociado, pases, desmarques y principios tácticos.'
}, {
  n: 'TOMO 5',
  Icon: Network,
  title: 'Táctica Avanzada y Transiciones',
  desc: '11 y 12 años. Sistemas de juego, transiciones rápidas y pelota parada.'
}, {
  n: 'TOMO 6',
  Icon: Briefcase,
  title: 'El Maletín del DT',
  desc: 'Planillas, evaluaciones, control de asistencia y herramientas de gestión.'
}];
export function TomosGrid() {
  return <section className="py-20 lg:py-24 bg-white" data-id="element-226">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14 max-w-3xl mx-auto" data-id="element-228">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-50 text-brand-700 font-bold text-xs uppercase tracking-wider mb-5 border border-brand-100" data-id="element-229">
            6 Tomos completos
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-ink-900 mb-4 leading-tight tracking-tight" data-id="element-230">
            Lo que recibís <span className="text-brand-500" data-id="element-231">hoy mismo</span>
          </h2>
          <p className="text-lg text-ink-600" data-id="element-232">
            Una biblioteca completa de Baby Fútbol, secuenciada y lista para
            aplicar.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-233">
          {tomos.map((tomo, i) => {
          const Icon = tomo.Icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="group relative bg-white rounded-3xl p-7 shadow-soft border border-ink-100 hover:shadow-card hover:-translate-y-1 hover:border-brand-200 transition-all overflow-hidden" data-id="element-234">
                {/* Corner accent */}
                <div className="absolute top-0 right-0 w-24 h-24 bg-brand-50 rounded-bl-[3rem] -translate-y-2 translate-x-2 group-hover:bg-brand-100 transition-colors" data-id="element-235"></div>

                <div className="relative z-10" data-id="element-236">
                  <div className="text-xs font-black tracking-[0.2em] text-brand-500 mb-3" data-id="element-237">
                    {tomo.n}
                  </div>
                  <div className="w-14 h-14 rounded-2xl bg-ink-900 text-brand-500 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform" data-id="element-238">
                    <Icon className="w-7 h-7" data-id="element-239" />
                  </div>
                  <h3 className="font-extrabold text-xl text-ink-900 mb-3 leading-tight" data-id="element-240">
                    {tomo.title}
                  </h3>
                  <p className="text-ink-600 leading-relaxed text-sm" data-id="element-241">
                    {tomo.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}